module.exports = __webpack_public_path__ + "img/mysql.d348e471.svg";